import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-385db5c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "user-code-wraper cola-color font-Pretendar text-center d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold text-80 text-20" }, [
  /*#__PURE__*/_createTextVNode(" 추가 제로 웨이스트 박스는 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1세트 당 10개씩 발송해 드려요! ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-5 text-14 text-54" }, " 필요한 박스 수만큼 신청해 주세요. ", -1))
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = { class: "select-wrapper" }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label text-54 text-18" }, "세트", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cola-color font-Pretendar" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mt-5 fw-bold text-20 text-80" }, " 박스 추가 신청 완료 "),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-3 text-14 text-54" }, [
    /*#__PURE__*/_createTextVNode(" 2~3일 내 회원가입 시 입력한 주소로 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 제로 웨이스트 박스가 발송됩니다. ")
  ])
], -1))
const _hoisted_9 = { class: "footer-btn-group" }

import ColaButton from '@/templates/campaign-cocacola-season-6/components/cola-button.vue';
import { inject, nextTick, reactive, ref } from 'vue';
import ParticipateSuccess from '@/templates/campaign-cocacola-season-6/components/participate-success.vue';
import { request } from '@/utils';
import _ from 'lodash';
import PopupError from '@/templates/campaign-cocacola-season-6/components/popups/popup-error.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const errMsg = ref('');
const popupVisible = reactive({
  success: false,
  requestWaitingLists: false,
  operationSuccess: false,
  step1Error: false,
  error: false,
});

const activeStep = ref(1);
const requestWaitingListsMessage = ref('');
const numbers5 = Array.from({ length: 5 }, (_, i) => i + 1);
const boxCount = ref(1);
const programStepData: any = inject('programStepData');
const handleSubmit = async () => {
  try {
    await request.post('additional_box_requests', {
      program_id: programStepData.value.programId,
      box_count: boxCount.value,
      notes: 'Onethepl6'
    }, {
      loading: { silent: true }
    });
    activeStep.value = 2;

  } catch (e) {
    const errorMsg = _.get(e, 'message');
    const code = _.get(e, 'code');
    const status = _.get(e, 'status');
    // // 项目人次达到上限，需要显示错误信息并提示是否订阅 waiting list
    if (status !== 401 && String(code) === '40008') {
      requestWaitingListsMessage.value = errorMsg;
      await showPopup('requestWaitingLists');
      return;
    }
    // request.ts已经处理过这个code了
    errMsg.value = errorMsg;
    await showPopup('error');
    throw e;
  }
};

async function showPopup(key: keyof typeof popupVisible) {
  hidePopup();
  await nextTick();
  popupVisible[key] = true;
}

function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    _.forEach(popupVisible, (val, key) => {
      if (val) {
        popupVisible[key] = false;
      }
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (activeStep.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((boxCount).value = $event)),
                  class: "custom-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numbers5), (n) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: n,
                      value: n
                    }, _toDisplayString(n), 9, _hoisted_6))
                  }), 128))
                ], 512), [
                  [_vModelSelect, boxCount.value]
                ]),
                _hoisted_7
              ])
            ])
          ]),
          _createVNode(ColaButton, {
            title: "박스 추가 신청하기",
            class: "mt-5 d-none d-sm-block",
            type: "button",
            border: true,
            onClick: handleSubmit
          }),
          _createVNode(ColaButton, {
            title: "박스 추가 신청하기",
            class: "mt-5 d-sm-none",
            type: "button",
            border: true,
            responsive: "",
            onClick: handleSubmit
          })
        ]))
      : _createCommentVNode("", true),
    (activeStep.value == 2)
      ? (_openBlock(), _createBlock(ParticipateSuccess, { key: 1 }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).error,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupVisible).error) = $event)),
      title: errMsg.value
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (hidePopup()))
          }, " 확인했어요 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})